import { prefetchPlayResource } from "@/features/play/records";
import { ProductRouteError } from "@/session/product-route-frame";
import { createFileRoute } from "@tanstack/react-router";
import { PlayActivityPage, PlayPending } from "@/features/play";

export const Route = createFileRoute(
  "/_site/unlisted/$coworld/$league/play_/activity",
)({
  loader: ({ context, location }) => {
    prefetchPlayResource({
      client: context.queryClient,
      href: location.href,
      resource: "activity",
    });
  },
  pendingComponent: PlayPending,
  errorComponent: ProductRouteError,
  head: () => ({
    meta: [
      { title: "Activity · Softmax" },
      { name: "robots", content: "noindex, follow" },
    ],
  }),
  component: PlayActivityPage,
});
